import React from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { Box, Flex, Text } from '@chakra-ui/core';

const ActivityProgressBar = ({ farmId, activities, duration, startDate, status }) => {
  let durationLeft = 'Ended';
  if (status !== 'completed') {
    let durationDate = moment(startDate)
      .add(duration, 'month')
      .format();
    durationLeft = 'Not started';
    if (moment() > moment(startDate)) {
      durationLeft = moment(durationDate).fromNow();
    }
  }

  let currentActivityArr = activities.filter(activity => activity.status === 'active');
  let currentActivityTitle = 'Not Started';
  let currentActivityTitleMultiple = null;
  if (currentActivityArr.length === 1) currentActivityTitle = currentActivityArr[0].title;
  else if (currentActivityArr.length > 1) {
    currentActivityTitleMultiple = currentActivityArr.map(currentActivity => (
      <Text as="span" color="white" bg="cf.400" fontSize={10} ml={2} py={1} px={2} rounded="sm">
        {currentActivity.title}
      </Text>
    ));
  }

  let progressedActive = activities.filter(activity => activity.status === 'active');
  let progressedActiveClass = 'w-full bg-cf-100';
  if (progressedActive.length === 0) {
    progressedActiveClass = '';
  } else {
    if (progressedActive.length < activities.length)
      progressedActiveClass =
        'w-' + progressedActive.length + '/' + activities.length + ' bg-cf-100';
  }

  let progressedCompleted = activities.filter(activity => activity.status === 'completed');
  let progressedCompletedClass = 'w-full bg-cf-300';
  if (progressedCompleted.length === 0) {
    progressedCompletedClass = '';
  } else {
    if (progressedCompleted.length < activities.length)
      progressedCompletedClass =
        'w-' + progressedCompleted.length + '/' + activities.length + ' bg-cf-300';
  }

  return (
    <>
      <Box fontSize="xs" pt={3} data-for={`main-${farmId}`} data-tip data-iscapture="true">
        <Flex
          wrap="wrap"
          align="center"
          w="100%"
          mt={2}
          borderWidth={1}
          borderColor="cf.400"
          rounded={1}
        >
          {progressedCompletedClass && (
            <Box px={2} py={3} className={progressedCompletedClass}></Box>
          )}
          {progressedActiveClass && <Box px={2} py={3} className={progressedActiveClass}></Box>}
          {!progressedCompletedClass && !progressedActiveClass && <Box px={2} py={3} />}
        </Flex>
      </Box>
      <ReactTooltip id={`main-${farmId}`} type="light" className="shadow-md">
        <Flex flexDir="column" fontWeight="semibold">
          <Box py={2}>
            {currentActivityTitleMultiple ? (
              <>
                On Going Activities:
                {currentActivityTitleMultiple}
              </>
            ) : (
              <>
                On Going Activity:
                <Text as="span" color="white" bg="cf.400" fontSize={10} py={1} px={2} rounded="sm">
                  {currentActivityTitle}
                </Text>
              </>
            )}
          </Box>
          <Box py={2}>
            Progress:{' '}
            <Text as="span" color="white" bg="cf.400" fontSize={10} py={1} px={2} rounded="sm">
              {durationLeft}
            </Text>
          </Box>
        </Flex>
      </ReactTooltip>

      <Box d={{ base: 'none', md: 'flex' }} flexWrap="wrap" justifyContent="space-between" mt={2}>
        {activities.map(activity => (
          <Text
            key={activity._id}
            fontSize={{ base: 'tiny', lg: 'xs' }}
            color={activity.status === 'completed' ? 'cf.400' : ''}
          >
            {activity.title}
          </Text>
        ))}
      </Box>
      <Flex
        align="center"
        justify="space-between"
        wrap="wrap"
        fontSize="tiny"
        mt={2}
        fontWeight="semibold"
        d={{ md: 'none' }}
      >
        <Box py={2}>
          {currentActivityTitleMultiple ? (
            <>
              On Going Activities:
              {currentActivityTitleMultiple}
            </>
          ) : (
            <>
              On Going Activity:
              <Text as="span" color="white" bg="cf.400" fontSize={10} py={1} px={2} rounded="sm">
                {currentActivityTitle}
              </Text>
            </>
          )}
        </Box>
        <Box>
          Progress:
          <Text as="span" color="white" bg="cf.400" fontSize={10} py={1} px={2} rounded="sm">
            {durationLeft}
          </Text>
        </Box>
      </Flex>
    </>
  );
};

export default ActivityProgressBar;
